import { render } from "./AdsTxtView.vue?vue&type=template&id=6776ec3e"
import script from "./AdsTxtView.vue?vue&type=script&lang=js"
export * from "./AdsTxtView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__